var _rect, _text, _rect2, _circle, _path, _text2, _rect3, _circle2, _path2, _text3, _rect4, _g, _g2, _g3, _rect5, _text4, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgApiKeys = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1000 570",
  width: 1000,
  height: 570,
  role: "img",
  "aria-label": "API keys screen",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 1000,
  height: 570,
  rx: 14,
  fill: "#F6F8FE"
})), _text || (_text = /*#__PURE__*/React.createElement("text", {
  x: 30,
  y: 75,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 28,
  fontWeight: 700,
  fill: "#172033"
}, "API Keys")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 842,
  y: 48,
  width: 136,
  height: 30,
  rx: 6,
  fill: "#2F6DF6"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 859,
  cy: 63,
  r: 5,
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 1.3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M859 60v6M856 63h6",
  stroke: "#FFFFFF",
  strokeWidth: 1.3
})), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
  x: 918,
  y: 67,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 11,
  fontWeight: 700,
  fill: "#FFFFFF",
  textAnchor: "middle"
}, "Create API Key")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 104,
  width: 948,
  height: 33,
  rx: 3,
  fill: "#FFFFFF",
  stroke: "#C8D0DC"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 120.5,
  r: 5,
  fill: "none",
  stroke: "#66728A",
  strokeWidth: 1.4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M51 124.5l5 5",
  stroke: "#66728A",
  strokeWidth: 1.4,
  strokeLinecap: "round"
})), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
  x: 72,
  y: 125,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 13,
  fill: "#66728A"
}, "Search for API key or Client ID")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 166,
  width: 948,
  height: 39,
  rx: 6,
  fill: "#FAFBFC",
  stroke: "#E8EDF4"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 9,
  fontWeight: 700,
  fill: "#263244"
}, /*#__PURE__*/React.createElement("text", {
  x: 42,
  y: 190
}, "Label"), /*#__PURE__*/React.createElement("text", {
  x: 165,
  y: 190
}, "Key"), /*#__PURE__*/React.createElement("text", {
  x: 282,
  y: 190
}, "Client Id"), /*#__PURE__*/React.createElement("text", {
  x: 402,
  y: 190
}, "Usage"), /*#__PURE__*/React.createElement("text", {
  x: 525,
  y: 190
}, "Credits"), /*#__PURE__*/React.createElement("text", {
  x: 665,
  y: 190
}, "Created On"), /*#__PURE__*/React.createElement("text", {
  x: 775,
  y: 190
}, "Last Used"), /*#__PURE__*/React.createElement("text", {
  x: 878,
  y: 190
}, "Status"), /*#__PURE__*/React.createElement("text", {
  x: 945,
  y: 190
}, "Actions"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFFFFF",
  stroke: "#E8EDF4"
}, /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 214,
  width: 948,
  height: 45,
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 269,
  width: 948,
  height: 45,
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 324,
  width: 948,
  height: 45,
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 379,
  width: 948,
  height: 45,
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 434,
  width: 948,
  height: 45,
  rx: 6
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 11,
  fill: "#334155"
}, /*#__PURE__*/React.createElement("text", {
  x: 42,
  y: 241
}, "Default key"), /*#__PURE__*/React.createElement("text", {
  x: 42,
  y: 296
}, "gt-test"), /*#__PURE__*/React.createElement("text", {
  x: 42,
  y: 351
}, "QA-test"), /*#__PURE__*/React.createElement("text", {
  x: 42,
  y: 406
}, "dans-03-06"), /*#__PURE__*/React.createElement("text", {
  x: 42,
  y: 461
}, "QA Test Key2"), /*#__PURE__*/React.createElement("text", {
  x: 165,
  y: 241
}, "1d***************"), /*#__PURE__*/React.createElement("text", {
  x: 165,
  y: 296
}, "76***************"), /*#__PURE__*/React.createElement("text", {
  x: 165,
  y: 351
}, "21***************"), /*#__PURE__*/React.createElement("text", {
  x: 165,
  y: 406
}, "e0***************"), /*#__PURE__*/React.createElement("text", {
  x: 165,
  y: 461
}, "f1***************"), /*#__PURE__*/React.createElement("text", {
  x: 282,
  y: 235
}, "qa-test-"), /*#__PURE__*/React.createElement("text", {
  x: 282,
  y: 250
}, "company"), /*#__PURE__*/React.createElement("text", {
  x: 282,
  y: 290
}, "qa-test-"), /*#__PURE__*/React.createElement("text", {
  x: 282,
  y: 305
}, "company"), /*#__PURE__*/React.createElement("text", {
  x: 282,
  y: 345
}, "qa-test-"), /*#__PURE__*/React.createElement("text", {
  x: 282,
  y: 360
}, "company"), /*#__PURE__*/React.createElement("text", {
  x: 282,
  y: 400
}, "qa-test-"), /*#__PURE__*/React.createElement("text", {
  x: 282,
  y: 415
}, "company"), /*#__PURE__*/React.createElement("text", {
  x: 282,
  y: 455
}, "qa-test-"), /*#__PURE__*/React.createElement("text", {
  x: 282,
  y: 470
}, "company"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 96,
  y: 230,
  width: 43,
  height: 15,
  rx: 7.5,
  fill: "#DDF0FF",
  stroke: "#8CC5FF"
})), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
  x: 117.5,
  y: 241,
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 8,
  fontWeight: 700,
  fill: "#2876DD",
  textAnchor: "middle"
}, "Default")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 11,
  fill: "#334155"
}, /*#__PURE__*/React.createElement("text", {
  x: 402,
  y: 241,
  fontWeight: 700
}, "3"), /*#__PURE__*/React.createElement("text", {
  x: 417,
  y: 241,
  fill: "#66728A"
}, "calls"), /*#__PURE__*/React.createElement("text", {
  x: 402,
  y: 296,
  fontWeight: 700
}, "1"), /*#__PURE__*/React.createElement("text", {
  x: 417,
  y: 296,
  fill: "#66728A"
}, "call"), /*#__PURE__*/React.createElement("text", {
  x: 402,
  y: 351,
  fontWeight: 700
}, "0"), /*#__PURE__*/React.createElement("text", {
  x: 417,
  y: 351,
  fill: "#66728A"
}, "calls"), /*#__PURE__*/React.createElement("text", {
  x: 402,
  y: 406,
  fontWeight: 700
}, "1"), /*#__PURE__*/React.createElement("text", {
  x: 417,
  y: 406,
  fill: "#66728A"
}, "call"), /*#__PURE__*/React.createElement("text", {
  x: 402,
  y: 461,
  fontWeight: 700
}, "0"), /*#__PURE__*/React.createElement("text", {
  x: 417,
  y: 461,
  fill: "#66728A"
}, "calls"), /*#__PURE__*/React.createElement("text", {
  x: 525,
  y: 235,
  fontWeight: 700
}, "6"), /*#__PURE__*/React.createElement("text", {
  x: 539,
  y: 235,
  fill: "#94A3B8"
}, "/ 16"), /*#__PURE__*/React.createElement("text", {
  x: 525,
  y: 290,
  fontWeight: 700
}, "2"), /*#__PURE__*/React.createElement("text", {
  x: 539,
  y: 290,
  fill: "#94A3B8"
}, "/ 14"), /*#__PURE__*/React.createElement("text", {
  x: 525,
  y: 345,
  fontWeight: 700
}, "0"), /*#__PURE__*/React.createElement("text", {
  x: 539,
  y: 345,
  fill: "#94A3B8"
}, "/ 1"), /*#__PURE__*/React.createElement("text", {
  x: 525,
  y: 400,
  fontWeight: 700
}, "2"), /*#__PURE__*/React.createElement("text", {
  x: 539,
  y: 400,
  fill: "#94A3B8"
}, "/ 14"), /*#__PURE__*/React.createElement("text", {
  x: 525,
  y: 455,
  fontWeight: 700
}, "0"), /*#__PURE__*/React.createElement("text", {
  x: 539,
  y: 455,
  fill: "#94A3B8"
}, "/ 980"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  stroke: "#EEF2F7",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  d: "M525 248H640"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525 303H640"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525 358H640"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525 413H640"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525 468H640"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  stroke: "#2F6DF6",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  d: "M525 248H568"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525 303H541"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525 413H541"
}))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 10,
  fill: "#334155"
}, /*#__PURE__*/React.createElement("text", {
  x: 665,
  y: 235
}, "06/02/2026,"), /*#__PURE__*/React.createElement("text", {
  x: 665,
  y: 250
}, "12:21 pm"), /*#__PURE__*/React.createElement("text", {
  x: 665,
  y: 290
}, "05/29/2026,"), /*#__PURE__*/React.createElement("text", {
  x: 665,
  y: 305
}, "07:38 am"), /*#__PURE__*/React.createElement("text", {
  x: 665,
  y: 345
}, "05/01/2026,"), /*#__PURE__*/React.createElement("text", {
  x: 665,
  y: 360
}, "01:56 am"), /*#__PURE__*/React.createElement("text", {
  x: 665,
  y: 400
}, "03/06/2026,"), /*#__PURE__*/React.createElement("text", {
  x: 665,
  y: 415
}, "04:38 pm"), /*#__PURE__*/React.createElement("text", {
  x: 665,
  y: 455
}, "02/07/2026,"), /*#__PURE__*/React.createElement("text", {
  x: 665,
  y: 470
}, "10:00 am"), /*#__PURE__*/React.createElement("text", {
  x: 775,
  y: 235
}, "06/09/2026,"), /*#__PURE__*/React.createElement("text", {
  x: 775,
  y: 250
}, "07:31 am"), /*#__PURE__*/React.createElement("text", {
  x: 775,
  y: 290
}, "06/02/2026,"), /*#__PURE__*/React.createElement("text", {
  x: 775,
  y: 305
}, "12:21 pm"), /*#__PURE__*/React.createElement("text", {
  x: 775,
  y: 345
}, "05/01/2026,"), /*#__PURE__*/React.createElement("text", {
  x: 775,
  y: 360
}, "02:19 am"), /*#__PURE__*/React.createElement("text", {
  x: 775,
  y: 400
}, "05/19/2026,"), /*#__PURE__*/React.createElement("text", {
  x: 775,
  y: 415
}, "09:23 am"), /*#__PURE__*/React.createElement("text", {
  x: 775,
  y: 455
}, "03/02/2026,"), /*#__PURE__*/React.createElement("text", {
  x: 775,
  y: 470
}, "04:43 pm"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  fontFamily: "Inter, DM Sans, Arial, sans-serif",
  fontSize: 11
}, /*#__PURE__*/React.createElement("circle", {
  cx: 882,
  cy: 238,
  r: 2,
  fill: "#2F8A4F"
}), /*#__PURE__*/React.createElement("text", {
  x: 892,
  y: 242,
  fill: "#2F8A4F"
}, "Active"), /*#__PURE__*/React.createElement("circle", {
  cx: 882,
  cy: 293,
  r: 2,
  fill: "#E5483F"
}), /*#__PURE__*/React.createElement("text", {
  x: 892,
  y: 297,
  fill: "#D33F35"
}, "Revoked"), /*#__PURE__*/React.createElement("circle", {
  cx: 882,
  cy: 348,
  r: 2,
  fill: "#E5483F"
}), /*#__PURE__*/React.createElement("text", {
  x: 892,
  y: 352,
  fill: "#D33F35"
}, "Revoked"), /*#__PURE__*/React.createElement("circle", {
  cx: 882,
  cy: 403,
  r: 2,
  fill: "#E5483F"
}), /*#__PURE__*/React.createElement("text", {
  x: 892,
  y: 407,
  fill: "#D33F35"
}, "Revoked"), /*#__PURE__*/React.createElement("circle", {
  cx: 882,
  cy: 458,
  r: 2,
  fill: "#E5483F"
}), /*#__PURE__*/React.createElement("text", {
  x: 892,
  y: 462,
  fill: "#D33F35"
}, "Revoked"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFFFFF",
  stroke: "#E1E7F0"
}, /*#__PURE__*/React.createElement("rect", {
  x: 940,
  y: 224,
  width: 28,
  height: 28,
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  x: 940,
  y: 279,
  width: 28,
  height: 28,
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  x: 940,
  y: 334,
  width: 28,
  height: 28,
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  x: 940,
  y: 389,
  width: 28,
  height: 28,
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  x: 940,
  y: 444,
  width: 28,
  height: 28,
  rx: 6
}))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
  fill: "#64748B"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 954,
  cy: 233,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 954,
  cy: 238,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 954,
  cy: 243,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 954,
  cy: 288,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 954,
  cy: 293,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 954,
  cy: 298,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 954,
  cy: 343,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 954,
  cy: 348,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 954,
  cy: 353,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 954,
  cy: 398,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 954,
  cy: 403,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 954,
  cy: 408,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 954,
  cy: 453,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 954,
  cy: 458,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 954,
  cy: 463,
  r: 1.5
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgApiKeys);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/api-keys.5c3cc0954e6362e4cabfb8e7591ff75a.svg";